import React, { useState } from "react";
import axios from "axios";

const ForgotPasswordPopup = ({ onClose }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent page reload
    console.log("Form submitted with email:", email); // Debug log

    setLoading(true);
    setError("");
    setMessage("");

    try {
      // Directly use axios to make the API call
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/users/forgot-password`, // Use the environment variable
        { email } // Pass the email as payload
      );

      console.log("API response:", response); // Debug log

      if (response.status === 200) {
        setMessage("Password recovery instructions sent to your email.");
      }
    } catch (err) {
      console.error("Error during password recovery:", err); // Debug log
      setError(err.response?.data?.message || "An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-gray-500 bg-opacity-50 backdrop-blur-sm">
      <div className="bg-yellow-300 rounded-lg shadow-lg p-8 w-full max-w-sm relative">
        {/* Close Button */}
        <button
          className="absolute top-4 right-4 text-black hover:text-gray-700 text-lg font-bold"
          onClick={onClose}
        >
          ✖
        </button>

        {/* Title */}
        <h2 className="text-2xl font-bold text-black mb-2 text-center">Recover Password</h2>
        <p className="text-gray-700 text-center mb-6">Enter your email to reset password</p>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div>
            <label className="block text-black font-medium mb-1">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full px-4 py-2 border border-black rounded-lg focus:outline-none focus:ring focus:ring-gray-400"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className={`w-full bg-black text-yellow-300 font-bold py-2 rounded-lg transition duration-200 ${loading ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-800"
              }`}
          >
            {loading ? "Sending..." : "Recover"}
          </button>
        </form>

        {/* Success or Error Message */}
        {message && (
          <p className="mt-4 text-green-600 text-center font-medium">{message}</p>
        )}
        {error && (
          <p className="mt-4 text-red-600 text-center font-medium">{error}</p>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordPopup;
